import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { MarkService } from "../http-api/mark.service";
import { Mark, MarkUpsert } from "../../_objects/mark";
import { map, tap } from "rxjs/operators";
import { TenantConfig } from "../../app.constants";

import D = TenantConfig.DefaultMarkWhenUploadingNoMarkImage.D;

@Injectable({
  providedIn: "root"
})
export class MarksStateService {
  private marksSubject = new BehaviorSubject<Mark>({
    createDate: "",
    createdBy: "",
    id: "",
    isDeleted: false,
    isValid: false,
    items: [],
    lastUpdateDate: "",
    lastUpdatedBy: "",
    schemaVersion: ""
  });
  public mark$ = this.marksSubject.asObservable();
  public markItems$ = this.mark$.pipe(map((data) => data.items));

  constructor(private markService: MarkService) {}

  public fetchAndUpdate(): Observable<Mark> {
    return this.markService.getMark().pipe(tap((data) => this.marksSubject.next(data)));
  }

  public upsertMark(markUpsert: MarkUpsert): Observable<Mark> {
    return this.markService.upsertMark(markUpsert).pipe(tap((data) => this.marksSubject.next(data)));
  }
}
